import styled from "styled-components";

export const ConsiderCard = styled.div`
    width: 100%;
    /* height: 150px; */
    word-wrap: break-word;
    white-space: normal;
    display: grid;
    justify-content: center;
    align-items: start;
    grid-auto-rows: min-content;
    row-gap: 20px;
`